import React from "react";
import theme from "theme";
import { Theme, Link } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml } from "@quarkly/components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"404"} />
		<Helmet>
			<title>
				一相科技官网-和流数字化-代决策
			</title>
			<meta name={"description"} content={"和流 heliu 数字化 和流数字化 一相科技官网 代决策"} />
			<meta property={"og:title"} content={"一相科技官网-和流数字化-代决策"} />
			<meta property={"og:description"} content={"让知道更自然"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/628dd8b721e43d0020958dcf/images/%E8%93%9D%E8%89%B2%E8%83%8C%E6%99%AF-%E5%92%8C%E6%B5%81%C2%AE%20LOGO%E5%9B%BE%E6%A0%87%20200x200_.jpeg?v=2023-02-15T09:39:51.187Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/628dd8b721e43d0020958dcf/images/%E9%80%8F%E6%98%8E%E8%83%8C%E6%99%AF-%E5%92%8C%E6%B5%81%C2%AE%20LOGO%E5%9B%BE%E6%A0%87%20200x200_.png?v=2023-02-14T14:13:53.180Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/628dd8b721e43d0020958dcf/images/%E9%80%8F%E6%98%8E%E8%83%8C%E6%99%AF-%E5%92%8C%E6%B5%81%C2%AE%20LOGO%E5%9B%BE%E6%A0%87%20200x200_.png?v=2023-02-14T14:13:53.180Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/628dd8b721e43d0020958dcf/images/%E9%80%8F%E6%98%8E%E8%83%8C%E6%99%AF-%E5%92%8C%E6%B5%81%C2%AE%20LOGO%E5%9B%BE%E6%A0%87%20200x200_.png?v=2023-02-14T14:13:53.180Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/628dd8b721e43d0020958dcf/images/%E9%80%8F%E6%98%8E%E8%83%8C%E6%99%AF-%E5%92%8C%E6%B5%81%C2%AE%20LOGO%E5%9B%BE%E6%A0%87%20200x200_.png?v=2023-02-14T14:13:53.180Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/628dd8b721e43d0020958dcf/images/%E9%80%8F%E6%98%8E%E8%83%8C%E6%99%AF-%E5%92%8C%E6%B5%81%C2%AE%20LOGO%E5%9B%BE%E6%A0%87%20200x200_.png?v=2023-02-14T14:13:53.180Z"} />
		</Helmet>
		<Link
			font={"--capture"}
			font-size={"10px"}
			position={"fixed"}
			bottom={"12px"}
			right={"12px"}
			z-index={"4"}
			border-radius={"4px"}
			padding={"5px 12px 4px"}
			background-color={"--dark"}
			opacity={"0.6"}
			hover-opacity={"1"}
			color={"--light"}
			cursor={"pointer"}
			transition={"--opacityOut"}
			quarkly-title={"Badge"}
			text-decoration-line={"initial"}
			href={"https://quarkly.io/"}
			target={"_blank"}
		>
			Made on Quarkly
		</Link>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"628dd8b721e43d0020958dcd"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
			<script place={"endOfHead"} rawKey={"6576abcd90c79f2113783a04"}>
				{" window.onload = function() {\n      document.title = '一相科技官网-和流数字化-代决策';\n}"}
			</script>
			<script crossorigin={""} place={"endOfBody"} rawKey={"6576b3b05bc762cc138e174f"}>
				{" window.onload = function() {\n      document.title = '一相科技官网-和流数字化-代决策';\n}"}
			</script>
		</RawHtml>
	</Theme>;
});